import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'

import Icon from 'Pods/Shared/Icon/Icon'

class DeleteConfirmationModal extends React.Component {
  constructor(props) {
    super(props)

    this.onModalClose = this.onModalClose.bind(this)
  }

  onModalClose(e) {
    this.setState({ isDisabledSubmit: false })
    this.props.closeModal(e)
  }

  render() {
    return (
      <Modal
        isOpen={this.props.modalIsOpen}
        shouldCloseOnOverlayClick
        contentLabel="Modal"
        ariaHideApp={false}
        className={{
          base: '',
          afterOpen: 'overlay-modal--container_after-open overlay-modal-container--xs',
          beforeClose: 'overlay-modal--container_before-close',
        }}
        overlayClassName={{
          base: 'overlay-modal--background',
          afterOpen: 'overlay-modal--background_after-open',
          beforeClose: 'overlay-modal--background_before-close',
        }}
      >
        <div className="overlay-modal" onClick={(e) => e.stopPropagation()}>
          <button className="btn btn-transparent overlay-modal--close-inner" onClick={this.onModalClose}>
            <Icon type={['fal', 'times']} color="grey-dark" />
          </button>
          <div className="overlay-modal--content overlay-modal--product overlay-modal--jobs">
            <h2 className="heading-18">Are you sure you want to delete your account?</h2>
            <h3 className="heading-16">Please note: This action is not reversable.</h3>
            <form action="/profile/settings/delete_account" method="post">
              <input type="hidden" name="authenticity_token" value={App.authenticityToken} />
              <div className="footer u-text-right u-mt10">
                <button className="cgt-button cgt-button--secondary cgt-button--medium" onClick={this.onModalClose}>
                  <span>No, keep my account</span>
                </button>
                <button
                  type="submit"
                  className="cgt-button cgt-button--primary cgt-button--medium cgt-ml-10"
                >
                  <span>Yes, delete my account</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    )
  }
}

DeleteConfirmationModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  modalIsOpen: PropTypes.bool,
}

DeleteConfirmationModal.defaultProps = {
  modalIsOpen: false,
}

export default DeleteConfirmationModal
